import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function exemplarPlacementsRoutes($stateProvider: StateProvider) {
    let exemplarPlacementsModule: { default: any; };
    $stateProvider
        .state({
            name: 'exemplar-placements',
            url: '/exemplar-placements',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => exemplarPlacementsModule.default,
            },
            lazyLoad: async () => {
                exemplarPlacementsModule = await import(/* webpackChunkName: "exemplarPlacements" */ './KpExemplarPlacementsPage.svelte');
                return null;
            }
        });
}